<template>
  <v-card
    class="mx-auto"
    max-width="344"
    height="175" max-height="175"
  >
    <v-card-text>
        <div>Total Documents</div>
        <div class="row">
            <div class="col-sm-6">
               <div class="d-flex h-100 card-primary-text" >
                  <span v-if="!category_loading">{{category_count}}</span>
                   <document-category-selector  class="flex-c" label="Category" multiple="false"  @input="getCategory"/>
               </div>
            </div>
            <div class="col-sm-6">
               <ul>
                    <li>Top 1</li>
                    <li>Top 2</li>
                    <li>Top 3</li>
                    <li>Top 4</li>
               </ul>
            </div>
        </div>
    </v-card-text>
  </v-card>
</template>
<script>
  import DocumentCategorySelector from "../../documents/CategoryFilter"
  export default {
      data:() =>({
        category_count : 0,
        category_loading: false
      }),
      components: {
        DocumentCategorySelector
      },
      props: {
        primary_text: Number,
        top_categories: Array,
      },
      methods: {
        async getCategory(category){
          this.category_loading= true
          this.category_count = await this.$store.dispatch('dashboard/fetchDocumentByCategory',category)
          this.category_loading= false
          
        },
      }
  }
</script>
<style scoped>
.h-100{
    height: 100%;
}
.card-primary-text{
    display: flex !important;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 50px;
}
</style>